import React from 'react'
import { useDispatch } from 'react-redux'

import { AtsLockContext } from 'components/common/AtsLock'

import { useTestsReportModal } from 'components/modals/TestsReportModal/hooks'
import { toInterview } from 'ducks/router'
import {
  useCandidateActions,
  useCandidateGroupActions,
  useCandidateState,
  useJobDetailsTab,
  useFilter,
} from './../hooks'

export const useJobInterviewsTab = state => {
  const { projectId } = state

  const dispatch = useDispatch()

  const { isAtsLocked } = React.useContext(AtsLockContext)

  const status = ['screened']

  const {
    state: { count, search },
    handlers: { setSearch },
  } = useJobDetailsTab()

  const {
    state: { filter },
    handlers: { setFilter },
  } = useFilter()

  const {
    state: {
      candidate,
      selected,
      selectedCandidates,
      hasMoveCandidatesFeature,
    },
    handlers: { setCandidate },
  } = useCandidateState()

  const {
    handleTestsReportModalClose: closeModal,
    handleTestsReportModalOpen,
    isTestsReportModalOpen,
  } = useTestsReportModal()

  const {
    state: {
      isCandidateManagementModalOpen,
      isDeleteCandidateModalOpen,
      isMoveCandidateModalOpen,
    },
    handlers: {
      getActions,
      handleFavorite,
      handleCandidateManagementModalClose,
      handleCandidateManagementModalConfirm,
      handleDeleteCandidateModalClose,
      handleDeleteCandidateModalConfirm,
      handleMoveCandidateModalClose,
      handleMoveCandidateModalConfirm,
    },
  } = useCandidateActions(
    { candidate, projectId, status, hasMoveCandidatesFeature, isAtsLocked },
    { handleSetCandidate: setCandidate },
  )

  const {
    state: {
      actions,
      isDeleteCandidateGroupModalOpen,
      isExportCandidateGroupModalOpen,
      isMoveCandidateGroupModalOpen,
    },
    handlers: {
      handleDeleteCandidateGroupModalClose,
      handleDeleteCandidateGroupModalConfirm,
      handleExportCandidateGroupModalClose,
      handleMoveCandidateGroupModalClose,
      handleMoveCandidateGroupModalConfirm,
    },
  } = useCandidateGroupActions({
    projectId,
    selected,
    status,
    hasMoveCandidatesFeature,
    isAtsLocked,
  })

  const handleInterview = React.useCallback(
    ({ id }) => {
      dispatch(toInterview({ uuid: id }))
    },
    [dispatch],
  )

  const handleTestsReportModalClose = () => {
    setCandidate(null)
    closeModal()
  }

  const handleTestsReport = React.useCallback(
    ({ candidate }) => {
      setCandidate(candidate)
      handleTestsReportModalOpen()
    },
    [handleTestsReportModalOpen, setCandidate],
  )

  const handleCompare = () => {
    handleTestsReportModalOpen()
  }

  const hasTwoCandidatesSelected = Object.keys(selected).length === 2

  return {
    state: {
      actions,
      candidate,
      count,
      search,
      filter,
      selectedCandidates,
      hasMoveCandidatesFeature,
      hasTwoCandidatesSelected,
      isCandidateManagementModalOpen,
      isDeleteCandidateModalOpen,
      isMoveCandidateModalOpen,
      isTestsReportModalOpen,
      isDeleteCandidateGroupModalOpen,
      isExportCandidateGroupModalOpen,
      isMoveCandidateGroupModalOpen,
    },
    handlers: {
      getActions,
      setFilter,
      handleFavorite,
      handleCandidateManagementModalClose,
      handleCandidateManagementModalConfirm,
      handleDeleteCandidateModalClose,
      handleDeleteCandidateModalConfirm,
      handleMoveCandidateModalClose,
      handleMoveCandidateModalConfirm,
      handleTestsReportModalClose,
      handleDeleteCandidateGroupModalClose,
      handleDeleteCandidateGroupModalConfirm,
      handleExportCandidateGroupModalClose,
      handleMoveCandidateGroupModalClose,
      handleMoveCandidateGroupModalConfirm,
      handleInterview,
      handleTestsReport,
      handleCompare,
      setSearch,
    },
  }
}
